import pricing from '@/constants/onboarding/pricing.json'

type Key = 'premisesInstallation' | 'insideInstallation' | 'outbuildingInstallation' | 'equipment' | 'telephone'
type PremisesInstallationMethod = 'trenching' | 'boring'
type InsideInstallationMethod = 'standardInstallation' | 'customInstallation'
type OutbuildingInstallationMethod = 'useExistingConduit' | 'trenching'
type Equipment = 'router1' | 'router2' | 'router3'
type Telephone = 'voip'

type Value = PremisesInstallationMethod | InsideInstallationMethod | OutbuildingInstallationMethod | Equipment | Telephone

function isPremisesInstallationMethod(value: Value): value is PremisesInstallationMethod {
	return [ 'trenching', 'boring', 'useExistingConduit' ].includes(value)
}

function isInsideInstallationMethod(value: Value): value is InsideInstallationMethod {
	return [ 'standardInstallation', 'customInstallation' ].includes(value)
}

function isOutbuildingInstallationMethod(value: Value): value is OutbuildingInstallationMethod {
	return [ 'useExistingConduit', 'trenching', 'boring', 'pointToPoint' ].includes(value)
}

function isEquipment(value: Value): value is Equipment {
	return [ 'router1', 'router2', 'router3' ].includes(value)
}

function isTelephone(value: Value): value is Telephone {
	return [ 'voip' ].includes(value)
}

const getPrice = (key: Key, value: Value) => {
	switch (key) {
		case 'premisesInstallation':
			if (isPremisesInstallationMethod(value)) {
				return pricing?.[key]?.[value]
			}
			break
		case 'insideInstallation':
			if (isInsideInstallationMethod(value)) {
				return pricing?.[key]?.[value]
			}
			break
		case 'outbuildingInstallation':
			if (isOutbuildingInstallationMethod(value)) {
				return pricing?.[key]?.[value]
			}
			break
		case 'equipment':
			if (isEquipment(value)) {
				return pricing?.[key]?.[value]
			}
			break
		case 'telephone':
			if (isTelephone(value)) {
				return pricing?.[key]?.[value]
			}
			break
		default:
			return 0
	}
}

const getTieredStaticIpPrice = (numberOfStaticIps: number) => {
	if (numberOfStaticIps === 1) {
		return 5
	} else if (numberOfStaticIps >= 2 && numberOfStaticIps <= 4) {
		return 10
	} else if (numberOfStaticIps > 4) {
		return 15
	}
	return 0
}

const getVoipPrice = (numberOfVoipLines: number) => {
	const VOIP_NUMBER_PRICE = 20
	return numberOfVoipLines ? VOIP_NUMBER_PRICE + (10 * (numberOfVoipLines - 1)) : 0
}

export {
	getPrice, getTieredStaticIpPrice, getVoipPrice
}
